// Temporary English fallbacks for message ids that have not been published to the
// shared translations repository yet. Keep this list in sync with external translations.
export const HardcodedTranslations = {};
